<div class="konto-profilkopf">
  <div class="konto-profilkopf__banner">
    <a class="konto-profilkopf__bearbeiten" data-testid="konto-profil-bearbeiten" routerLink="/account/profile">
      <mat-icon class="konto-profilkopf__bearbeiten-icon" aria-hidden="true">edit</mat-icon>
      {{ 'account.profilkopf.bearbeiten' | translate }}
    </a>
  </div>

  <div class="konto-profilkopf__kopf">
    <div class="konto-profilkopf__avatar" aria-hidden="true">
      <app-avatar [name]="profil().displayName" [size]="88" [benutzerId]="profil().id" />
    </div>
    <div class="konto-profilkopf__name">{{ profil().displayName }}</div>
    <div class="konto-profilkopf__email">{{ profil().email }}</div>
    <div class="konto-profilkopf__rolle-zeile">
      <span class="konto-profilkopf__rolle" [attr.data-rolle]="rolle()">
        <span class="konto-profilkopf__rolle-punkt" aria-hidden="true"></span>
        {{ 'account.role.' + rolle() | translate }}
      </span>
    </div>
  </div>

  <dl class="konto-profilkopf__fusszeile">
    <div>
      <dt>{{ 'account.meta.language' | translate }}</dt>
      <dd>{{ sprache() }}</dd>
    </div>
    <div>
      <dt>{{ 'account.meta.timezone' | translate }}</dt>
      <dd>{{ zeitzone() }}</dd>
    </div>
    <div>
      <dt>{{ 'account.meta.memberSince' | translate }}</dt>
      <dd>{{ mitgliedSeit() }}</dd>
    </div>
  </dl>
</div>
